import React, { useContext, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import { StoreContext } from "../../../store/Provider";
import SearchIcon from "@mui/icons-material/Search";
import "./mergeorder.css";
import { path } from "../../constants/apiPath";
import instance from "../../common/api/interceptor";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import { NotificationManager } from "react-notifications";
import { CircularProgress } from "@material-ui/core";
import { OrderContext as OrderListContext } from "../orderList/store/index";
import { StoreContext as OrderContext } from "../../store/index";
import { baseURL, LOCAL_STORAGE_KEY } from "../../../config";

const MergeOrder = () => {
  const context = useContext(StoreContext);
  const [orderlist, setOrderlist] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const { setApprovedData, setShippedData, setRejectedData, setArchiveData } =
    useContext(OrderListContext);
  const { setDashboardData } = useContext(OrderContext);

  const handlechange = (e, item) => {
    console.log(e);
    if (e) {
      const orderPkList = [...checkedList];
      orderPkList.push(item);
      setCheckedList([...orderPkList]);
    } else {
      const index = checkedList.findIndex((ele) => {
        return ele.OrderPK === item.OrderPK;
      });

      const orderPkList = [...checkedList];
      orderPkList.splice(index, 1);
      setCheckedList([...orderPkList]);

      console.log(index);
    }
  };

  useEffect(() => {
    getOrderForAttach();
  }, []);

  const getOrderForAttach = (searchValue = "") => {
    setLoading(true);
    const axios = require("axios");
    const data = JSON.stringify({
      SearchData: searchValue,
      OrgCodes: "",
      Status: "",
      SortColumnName: "",
      SortDirection: "",
      CurrentPage: 0,
      PageSize: 0,
    });

    const token = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
    );
    var config = {
      method: "post",
      url:
        baseURL +
        path.GET_ORDER_FOR_ATTACH +
        `?orderPk=${context.notificationOpen.orderPk}&role=${context.omsUserData.UserRoles}`,
      headers: {
        Authorization: `Bearer ${token.access_token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        setLoading(false);
        if (response.data.Is_Success) {
          setOrderlist(response.data.data ?? []);
        }
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const attachOrder = () => {
    const order = [];
    checkedList.map((item) => {
      order.push({
        FK: item.OrderPK,
      });
    });
    const body = {
      Pk: context.notificationOpen.orderPk,
      FKs: [...order],
    };

    instance
      .post(path.ATTACH_ORDER, body)
      .then((res) => {
        if (res.Is_Success) {
          setDashboardData({});
          setApprovedData({
            data: [],
            page: 0,
            hasMore: false,
          });
          setShippedData({
            data: [],
            page: 0,
            hasMore: false,
          });
          setRejectedData({
            data: [],
            page: 0,
            hasMore: false,
          });
          setArchiveData({
            data: [],
            page: 0,
            hasMore: false,
          });
          NotificationManager.success(res.Message, "", 3000);
          setCheckedList([]);
          getOrderForAttach();
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
      });
  };
  return (
    <div className="_notificationSetting">
      <div className="_notificationSettingHeader">
        <h5>Merge Order</h5>
        <Button
          title={"Close"}
          onClick={() =>
            context.setNotificationOpen({
              open: false,
              type: "",
              reload: false,
            })
          }
        >
          <CloseIcon />
        </Button>
      </div>
      <div className="SearchDivMergeOrder">
        <div className="_orderSearch">
          <SearchIcon />
          <input
            className="form-control"
            placeholder="Search"
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                getOrderForAttach(searchValue);
              }
            }}
          />
        </div>
        <div>
          <Button
            variant="contained"
            className="_orderHeaderdetailActionButton _orderDetailsViewLog"
            onClick={() => getOrderForAttach(searchValue)}
          >
            Search
          </Button>
        </div>
      </div>
      {checkedList.length ? (
        <div className="_mergeorderchip">
          {checkedList.map((item) => {
            return (
              <Chip
                className="_chipOrdermerge"
                label={item.OrderNumber}
                onDelete={() => handlechange(false, item)}
              />
            );
          })}
        </div>
      ) : null}
      {loading ? (
        <div className="bottomLoader">
          <CircularProgress size="1.5rem" />
        </div>
      ) : (
        <div className="mergeOrderTable">
          <table
            id="dtDynamicVerticalScrollExample"
            className="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr>
                <th className="th-sm"></th>
                <th className="th-sm">Order Number</th>
                <th className="th-sm">Buyier Code</th>
                <th className="th-sm">Supplier Code</th>
              </tr>
            </thead>
            <tbody>
              {orderlist.map((item) => {
                const orderNumber =
                  item.SplitNumber == "0"
                    ? `${item.OrderNumber}`
                    : `${item.OrderNumber}/${item.SplitNumber}`;
                const checked = checkedList.findIndex(
                  (i) => item.OrderPK === i.OrderPK
                );
                return (
                  <tr>
                    <th scope="row">
                      <Checkbox
                        checked={checked !== -1 ? true : false}
                        onChange={(e) => handlechange(e.target.checked, item)}
                      />
                    </th>
                    <td title={item.OrderNumber}>{orderNumber}</td>
                    <td title={item.OrderBuyerCode}>{item.OrderBuyerCode}</td>
                    <td title={item.OrderSupplierCode}>
                      {item.OrderSupplierCode}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {checkedList.length ? (
        <div className="buttonmergeorder">
          <Button
            onClick={() => attachOrder()}
            variant="contained"
            className="_orderHeaderdetailActionButton _orderDetailsViewLog"
          >
            Merge Order
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default MergeOrder;
